<template>
  <div class="has-add-popup">
    <div class='hap-img'>
      <img :src='actionGif' alt=""/>
    </div>
    <div class='hap-soldout'>
      <span>已加入收藏夹，正在返回首页~</span>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'

export default {
  data () {
    return {
      actionGif: IMG_BASE_URL + '/upaiyun/Sys/20180508/4824525880709225818.gif'
    }
  }
}
</script>

<style scoped>
  .has-add-popup{
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    padding: 4% 4% 0;
    bottom: 0;
    max-height: 86%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .hap-img{
    width: 11.5em;
    height: 11.5em;
    margin:3em auto 0;
  }
  .hap-img img{
    width: 100%;
    height: 100%;
  }
  .hap-soldout{
    text-align: center;
    font-weight: bold;
    margin-top:3.8em;
    line-height:2.3em;
  }
</style>
